import $ from "jquery";
import FlipCounter from "./FlipCounter";

import "./OkCountdown.scss";

class OkCountdown {
	constructor(params) {
		Object.keys(params).forEach((key) => {
			this[key] = params[key];
		});

		this.$container = $(this.container);

		if (!this.container || !this.$container.length) {
			return;
		}

		this.el = $(this.html);
		this.el.addClass("hasflip showhours");
		this.container.append(this.el);

		if (this.now && this.deadline) {
			this.setTimeLeft(this.deadline - this.now);

			this.updater = setInterval(() => {
				this.update();
			}, 1000);
		}
	}

	html = `
<div class="okcountdown">
	<div class="flipper hours"></div>
	<div class="colon hourscolon">:</div>
	<div class="flipper minutes"></div>
	<div class="colon minutescolon">:</div>
	<div class="flipper seconds"></div>
</div>`;

	setTimeLeft(timeleft) {
		this.timeleft = timeleft;

		const onehour = 60 * 60;
		this.hours = Math.floor(this.timeleft / onehour);
		this.minutes = Math.floor((this.timeleft - this.hours * onehour) / 60);
		this.seconds = this.timeleft % 60;

		// init the flippers
		this.hoursroller = new FlipCounter(
			this.el.find(".flipper.hours"),
			{
				number: this.hours,
				padZeroes: 2,
			},
		);

		this.minutesroller = new FlipCounter(
			this.el.find(".flipper.minutes"),
			{
				number: this.minutes,
				lowerBound: 0,
				lowerWrap: 59,
				padZeroes: 2,
			},
		);

		this.secondsroller = new FlipCounter(
			this.el.find(".flipper.seconds"),
			{
				number: this.seconds,
				lowerBound: 0,
				lowerWrap: 59,
				padZeroes: 2,
			},
		);
	}

	update() {
		if (this.stopped) {
			return;
		}

		// If we're done, we're done
		if (this.timeleft === 0) {
			this.finish();
			return;
		}

		// otherwise, decrement by one second
		this.timeleft -= 1;
		this.seconds -= 1;
		this.secondsroller.decrement();

		// Roll over minute
		if (this.seconds === -1) {
			this.seconds = 59;
			this.minutes -= 1;
			this.minutesroller.decrement();

			// Roll over hour
			if (this.minutes === -1) {
				this.minutes = 59;
				this.hours -= 1;
				this.hoursroller.decrement();
			}
		}
	}

	finish() {
		this.stop();

		if (this.onfinish && typeof this.onfinish === "function") {
			this.onfinish();
		}
	}

	stop() {
		clearInterval(this.updater);
		this.stopped = true;
	}
}

export default OkCountdown;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Promos/OkCountdown.js